// composables/useNavigation.js
import { ref, computed } from 'vue'

// Singleton state - SVE mora biti reaktivno
const activeTab = ref('home')
const activeView = ref('home')
const isUserAuthenticated = ref(false)
const useCustomHeader = ref(false)
const menuItems = ref([])  

const defaultMenuItems = [
  { id: 'home', label: 'Home', icon: 'home', public: true, tabs: true }
]

export function useNavigation(config = null) {
  // Postavi menuItems samo prvi put
  if (config != null && menuItems.value.length === 0) {
    menuItems.value = config.menuItems || defaultMenuItems
    
    // Postavi default values iz configa
    if (config.defaultTab) activeTab.value = config.defaultTab
    if (config.defaultView) activeView.value = config.defaultView
    if (config.useCustomHeader !== undefined) useCustomHeader.value = config.useCustomHeader
  }

  const tabs = computed(() => {
    return menuItems.value.filter(item => { 
      if (!item.tabs) return false
      return item.public || isUserAuthenticated.value
    })
  })

  const publicMenuItems = computed(() => menuItems.value.filter(item => item.public))  
  const privateMenuItems = computed(() => menuItems.value)

  const setAuthStatus = (status) => {
    isUserAuthenticated.value = status
  }

  const setActiveTab = (tabId) => {
    const foundTab = menuItems.value.find(item => item.tabs && item.id === tabId) 
    if (foundTab) {
      activeTab.value = activeView.value = tabId
    }
  }

  const setActiveView = (viewId) => {
    const foundView = menuItems.value.find(item => item.id === viewId) 
    if (foundView) {
      activeView.value = viewId
      activeTab.value = foundView.tabs ? viewId : null
    }
  }

  return {
    activeTab,
    activeView,
    menuItems, 
    tabs,
    publicMenuItems,
    privateMenuItems,
    setActiveTab,
    setActiveView,
    useCustomHeader,
    setAuthStatus,
    isUserAuthenticated
  }
}